import type { FocusedField } from '../types';

/**
 * Checks if a specific field is currently focused
 * @param currentField - The field to check
 * @param focusedField - The currently focused field
 * @returns true if the field is focused, false otherwise
 */
export const isFieldFocused = (currentField: FocusedField, focusedField: FocusedField): boolean => {
	return focusedField === currentField;
};

/**
 * Determines if text should be highlighted based on focus and content state
 * @param isFocused - Whether the field is focused
 * @param hasContent - Whether the field has actual content (not placeholder)
 * @returns true if text should be highlighted, false otherwise
 */
export const shouldHighlightText = (isFocused: boolean, hasContent: boolean): boolean => {
	return isFocused && hasContent;
};
